const pricingContent = {
    hero: {
        label: 'PLATFORM PRICING',
        title: 'Direct mail pricing that scales',
        accent: 'with your volume.',
        description:
            'Pick a plan that fits how much you mail today. No minimums, no long-term contract on self-serve plans, and every plan includes address verification and NCOA out of the box.',
        billing: [
            {
                id: 'monthly',
                label: 'Monthly',
            },
            {
                id: 'annual',
                label: 'Annual',
                badge: 'Save ~16%',
            },
        ],
    },
    plans: [
        {
            id: 'starter',
            name: 'Starter',
            monthly: '$0',
            annual: '$0',
            period: '/month',
            annualNote: '',
            description: 'Best for getting started with direct mail.',
            cta: {
                label: 'Start for Free',
                href: 'https://app.openlettermarketing.com/signup',
            },
            volume: 'Best for up to 500 pieces/mo',
            intro: '',
            features: [
                '3 users',
                'Standard mailpiece rates',
                'List builder access',
                'Unlimited templates, tags & contacts',
                'Address verification & NCOA',
                'Shopify & GoHighLevel integrations',
                'Test-mode API access',
                'Email & chat support',
            ],
        },
        {
            id: 'growth',
            name: 'Growth',
            monthly: '$99',
            annual: '$83',
            period: '/month',
            annualNote: 'Billed annually at $996/yr',
            description:
                'Best for teams sending consistent, automated campaigns.',
            cta: {
                label: 'Get Started',
                href: 'https://app.openlettermarketing.com/signup',
            },
            volume: 'Best for up to 3,000 pieces/mo',
            intro: 'Everything in Starter, plus:',
            features: [
                '5 users',
                'Low mailpiece rates',
                'Full API access',
                'Multi-touch campaigns',
                'HubSpot integration',
                '2 monthly design credits',
                'Schedule mail',
            ],
        },
        {
            id: 'pro',
            name: 'Professional',
            monthly: '$199',
            annual: '$167',
            period: '/month',
            annualNote: 'Billed annually at $1,999/yr',
            description:
                'Best for teams needing more seats and hands-on support.',
            cta: {
                label: 'Get Started',
                href: 'https://app.openlettermarketing.com/signup',
            },
            volume: 'Best for up to 6,000 pieces/mo',
            intro: 'Everything in Growth, plus:',
            features: [
                '7 users',
                'Lower mailpiece rates',
                '4 monthly design credits',
                'Dedicated account manager',
                'Onboarding & training included',
            ],
        },
        {
            id: 'enterprise',
            name: 'Enterprise',
            monthly: 'Custom',
            annual: 'Custom',
            period: '',
            annualNote: '',
            description: 'Best for high-volume senders needing custom rates.',
            cta: {
                label: 'Talk to Sales',
                href: '/contact-us',
            },
            volume: 'For 6,000+ pieces/mo',
            intro: '',
            features: [
                'Unlimited users',
                'Lowest mailpiece rates',
                'Priority list builder & data access',
                'Custom fields & webhooks',
                'Priority API access',
                'Custom CRM / SDK integration support',
                'Dedicated account manager',
            ],
        },
    ],
    comparison: {
        title: 'Compare plans in',
        accent: 'full detail.',
        label: 'Feature',
        groups: [
            {
                title: 'Account Limits',
                rows: [
                    {
                        label: 'Users',
                        subtitle: '',
                        values: [['3'], ['5'], ['7'], ['Custom']],
                    },
                    {
                        label: 'Templates, tags & contacts',
                        subtitle: '',
                        values: [
                            ['Unlimited'],
                            ['Unlimited'],
                            ['Unlimited'],
                            ['Unlimited'],
                        ],
                    },
                    {
                        label: 'Custom fields',
                        subtitle: '',
                        values: [
                            ['Unlimited'],
                            ['Unlimited'],
                            ['Unlimited'],
                            ['Unlimited'],
                        ],
                    },
                    {
                        label: 'Typical monthly mail volume',
                        subtitle: '',
                        tooltip:
                            "A planning guide, not a hard limit. Sends are never paused — consistently mailing above your plan's range is usually just a sign it's time for a custom contract.",
                        values: [
                            ['Up to 500'],
                            ['Up to 3,000'],
                            ['Up to 6,000'],
                            ['Any volume'],
                        ],
                    },
                    {
                        label: 'Monthly design credits',
                        subtitle: '',
                        tooltip:
                            'One design credit covers a custom mailpiece template built by our design team, from concept to a print-ready file.',
                        values: [['0'], ['2'], ['4'], ['Custom']],
                    },
                ],
            },
            {
                title: 'Platform Features',
                rows: [
                    {
                        label: 'Drag-and-drop template builder',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Variable data & personalization',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Variable images',
                        subtitle: '',
                        tooltip:
                            'Swap in a different image per recipient on the same mailpiece, based on their data.',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Mail tracking',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Mail and attribution dashboards',
                        subtitle: '',
                        tooltip:
                            'See delivery, response, and ROI for every mailer you send, all in one place.',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'USPS address verification, NCOA & standardization',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'QR codes',
                        subtitle: '',
                        tooltip:
                            'A scannable code printed on your mailpiece that takes the recipient straight to a page or offer you choose.',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'PURLs',
                        subtitle: '',
                        tooltip:
                            'A trackable, personalized landing page URL printed on each mailpiece so you can see who responds online.',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Phone tracking numbers',
                        subtitle: '',
                        tooltip:
                            'A dedicated number printed on your mailpiece to track and record the calls it generates. Billed separately as an add-on.',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Bulk contact import & export',
                        subtitle: '',
                        values: [['Import only'], true, true, true],
                    },
                    {
                        label: 'Scheduled sends',
                        subtitle: '',
                        values: [false, true, true, true],
                    },
                    {
                        label: 'Multi-touch campaigns',
                        subtitle: '',
                        tooltip:
                            'Automatically send a sequence of mailpieces over time, triggered by a schedule or your CRM.',
                        values: [false, true, true, true],
                    },
                    {
                        label: 'User roles & permissions',
                        subtitle: '',
                        values: [false, true, true, true],
                    },
                    {
                        label: 'Suppression list',
                        subtitle: '',
                        values: [false, true, true, true],
                    },
                    {
                        label: 'SMS and QR Code event notifications',
                        subtitle: '',
                        tooltip:
                            'Get an email notification the moment a recipient scans a QR code or responds by text.',
                        values: [false, true, true, true],
                    },
                ],
            },
            {
                title: 'Data & Targeting',
                id: 'data-targeting',
                rows: [
                    {
                        label: 'Consumer data',
                        subtitle: '',
                        tooltip:
                            'Target and pull consumer records based on demographic and property filters.',
                        values: [
                            ['$0.15 /record'],
                            ['$0.12 /record'],
                            ['$0.10 /record'],
                            ['Custom'],
                        ],
                    },
                    {
                        label: 'Business data',
                        subtitle: '',
                        tooltip:
                            'Target and pull business records based on business filters.',
                        values: [
                            ['$0.15 /record'],
                            ['$0.12 /record'],
                            ['$0.10 /record'],
                            ['Custom'],
                        ],
                    },
                    {
                        label: 'Radius targeting',
                        subtitle: '',
                        tooltip:
                            'Mail homes within a set radius around a property address.',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Service area targeting',
                        subtitle: '',
                        tooltip:
                            'Draw a custom boundary on a map to build a mailing list for that area.',
                        values: [true, true, true, true],
                    },
                ],
            },
            {
                title: 'Mail Products',
                rows: [
                    {
                        label: 'Postcards',
                        subtitle: '(4×6, 6×9, 6×11, 9×12)',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Letters',
                        subtitle: '(personal & professional)',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Snap packs',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Self mailers',
                        subtitle: '(6×18, 8.5×11)',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Real penned letters',
                        subtitle: '(personal & professional)',
                        tooltip:
                            'Written with an actual pen, so each letter looks hand-addressed and hand-signed.',
                        values: [true, true, true, true],
                    },
                ],
            },
            {
                title: 'Integrations',
                rows: [
                    {
                        label: 'Zapier',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Shopify',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'GoHighLevel',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'HubSpot',
                        subtitle: '',
                        values: [false, true, true, true],
                    },
                ],
            },
            {
                title: 'API & SDK',
                rows: [
                    {
                        label: 'API access',
                        subtitle: '',
                        values: [
                            ['Test only'],
                            ['Full access'],
                            ['Full access'],
                            ['Priority access'],
                        ],
                    },
                    {
                        label: 'SDK & White Labeling',
                        subtitle: '',
                        tooltip:
                            'Build fully custom mailpiece templates programmatically and white-label the platform under your own brand.',
                        values: [false, false, false, true],
                    },
                    {
                        label: 'Webhooks',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                ],
            },
            {
                title: 'Support',
                rows: [
                    {
                        label: 'Email & chat support',
                        subtitle: '',
                        values: [true, true, true, true],
                    },
                    {
                        label: 'Phone support',
                        subtitle: '',
                        values: [false, true, true, true],
                    },
                    {
                        label: 'Custom CRM integration support',
                        subtitle: '',
                        values: [false, false, true, true],
                    },
                    {
                        label: 'Dedicated account manager',
                        subtitle: '',
                        values: [false, false, true, true],
                    },
                    {
                        label: 'Onboarding & training',
                        subtitle: '',
                        values: [false, false, true, true],
                    },
                ],
            },
        ],
    },
    perPiece: {
        title: 'Per-piece mail pricing',
        description:
            'Every mailpiece is billed per piece on top of your monthly platform fee. Rates drop as you move up plans.',
        label: 'Mailpiece',
        columns: ['Starter', 'Growth', 'Professional', 'Enterprise'],
        groups: [
            {
                title: 'Postcards',
                rows: [
                    {
                        label: '4×6 Postcard',
                        subtitle: '',
                        values: [
                            ['$0.898 FC', '$0.849 SC'],
                            ['$0.677 FC', '$0.628 SC'],
                            ['$0.627 FC', '$0.578 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: '6×9 Postcard',
                        subtitle: '',
                        values: [
                            ['$1.012 FC', '$0.960 SC'],
                            ['$0.726 FC', '$0.677 SC'],
                            ['$0.689 FC', '$0.640 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: '6×11 Postcard',
                        subtitle: '',
                        values: [
                            ['$1.294 FC', '$1.040 SC'],
                            ['$0.990 FC', '$0.737 SC'],
                            ['$0.960 FC', '$0.707 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: '9×12 Postcard',
                        subtitle: '',
                        values: [
                            ['$2.044 FC', '$1.744 SC'],
                            ['$1.990 FC', '$1.690 SC'],
                            ['$1.960 FC', '$1.660 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Letters',
                rows: [
                    {
                        label: 'Personal Letters',
                        subtitle: '',
                        values: [
                            ['$1.400 FC', '$1.130 SC'],
                            ['$1.200 FC', '$0.930 SC'],
                            ['$1.150 FC', '$0.880 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: 'Professional Letters',
                        subtitle: '#10 Double-Window',
                        values: [
                            ['$1.290 FC', '$1.020 SC'],
                            ['$1.090 FC', '$0.820 SC'],
                            ['$1.040 FC', '$0.770 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: 'Professional Letters',
                        subtitle: '',
                        values: [
                            ['$1.400 FC', '$1.130 SC'],
                            ['$1.200 FC', '$0.930 SC'],
                            ['$1.150 FC', '$0.880 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Snap Packs',
                rows: [
                    {
                        label: 'Snap Pack Self-Mailer',
                        subtitle: '',
                        values: [
                            ['$1.350 FC', '$1.080 SC'],
                            ['$1.150 FC', '$0.880 SC'],
                            ['$1.100 FC', '$0.830 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Self Mailers',
                rows: [
                    {
                        label: '6×18 Bi-Fold Self-Mailer',
                        subtitle: '',
                        values: [
                            ['$1.380 FC', '$1.110 SC'],
                            ['$1.180 FC', '$0.910 SC'],
                            ['$1.130 FC', '$0.860 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: '8.5×11 Tri-Fold Self-Mailer',
                        subtitle: '',
                        values: [
                            ['$1.380 FC', '$1.110 SC'],
                            ['$1.180 FC', '$0.910 SC'],
                            ['$1.130 FC', '$0.860 SC'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Real Penned Letters',
                rows: [
                    {
                        label: 'Real Penned Letter',
                        subtitle: 'First Class Forever',
                        values: [
                            ['$1.990'],
                            ['$1.820'],
                            ['$1.768'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: 'Real Penned Professional Letter',
                        subtitle: 'First Class',
                        values: [
                            ['$1.690'],
                            ['$1.520'],
                            ['$1.468'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Add-Ons',
                rows: [
                    {
                        label: 'Additional Page',
                        subtitle: 'Professional Letter',
                        values: [
                            ['$0.12'],
                            ['$0.12'],
                            ['$0.12'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: 'Google Streetview',
                        subtitle: '',
                        tooltip:
                            'Adds a Google Street View image of the property to the mailpiece.',
                        values: [
                            ['$0.02'],
                            ['$0.02'],
                            ['$0.02'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                    {
                        label: 'Property Offers',
                        subtitle: '',
                        tooltip:
                            'Adds a personalized property value estimate to the mailpiece.',
                        values: [
                            ['$0.03'],
                            ['$0.03'],
                            ['$0.03'],
                            {
                                label: 'Talk to Sales',
                                href: 'https://app.openlettermarketing.com/signup',
                            },
                        ],
                    },
                ],
            },
        ],
        footnote:
            'FC = First Class postage, SC = Standard Class postage. Prices are per piece and exclude your monthly platform fee.',
        link: {
            href: '#data-targeting',
            label: 'Data & Targeting',
        },
        footnoteEnd: 'above for consumer and business data pricing.',
    },
    addons: {
        title: 'Add-ons',
        description: 'Extend any plan with optional services.',
        items: [
            {
                name: 'Tracking Phone Numbers',
                price: '$5.00',
                suffix: '/mo per number',
                pending: false,
                description:
                    'Dedicated tracking numbers to measure call response from a mail campaign, on any plan.',
            },
            {
                name: 'Design Credits',
                price: 'From $85',
                suffix: '/credit',
                pending: false,
                description:
                    'Covers a custom mailpiece template built by our design team. Sold in packages — price per credit drops the more you buy.',
            },
            {
                name: 'Address Verification API',
                price: 'Pricing TBD',
                suffix: '',
                pending: true,
                description:
                    "Higher-volume address verification and standardization above your plan's included usage.",
            },
            {
                name: 'Integration Setup',
                price: '$99',
                suffix: '',
                pending: false,
                description:
                    'One-time setup for a custom CRM or workflow integration. Available on paid plans only (Growth, Professional, or Enterprise) — not on Starter.',
            },
        ],
    },
    faq: {
        title: 'Pricing questions, answered.',
        items: [
            {
                id: 'pricing-faq-0',
                question: 'Can I switch plans later?',
                answer: 'Yes. You can upgrade or downgrade at any time from your account settings. Changes take effect on your next billing cycle.',
            },
            {
                id: 'pricing-faq-1',
                question: 'How does per-piece pricing work?',
                answer: 'Every plan pays a per-piece rate on top of the monthly platform fee, and that rate drops as you move up plans. See the full rate card above for exact pricing by mailpiece and format.',
            },
            {
                id: 'pricing-faq-2',
                question: 'Is postage included in the per-piece price?',
                answer: "Yes. Every per-piece rate includes printing and postage. There's nothing added at checkout beyond your monthly platform fee and any add-ons you choose.",
            },
            {
                id: 'pricing-faq-3',
                question: 'Do I need to know how to code to use the platform?',
                answer: "No. The drag-and-drop template builder and campaign tools are built for no-code use. The API and SDK are there if your team wants to build custom integrations, but they're optional.",
            },
            {
                id: 'pricing-faq-4',
                question: 'Do you offer a discount for annual billing?',
                answer: 'Yes. Paying annually saves roughly two months compared to paying monthly on Growth and Professional.',
            },
            {
                id: 'pricing-faq-5',
                question: 'What happens to unused design credits?',
                answer: "Design credits don't roll over. Unused credits expire at the end of your monthly billing cycle.",
            },
            {
                id: 'pricing-faq-6',
                question: "What's included in Enterprise?",
                answer: 'Enterprise is built for agencies, franchises, and high-volume mailers: custom per-piece rates, unlimited users, priority API access, and a dedicated account manager. Talk to sales for a quote based on your volume.',
            },
        ],
    },
    cta: {
        title: 'Pick a plan and start mailing today.',
        description:
            'No minimums, no setup fees on self-serve plans, and every plan includes address verification and NCOA.',
        cta: {
            label: 'Get Started',
            href: 'https://app.openlettermarketing.com/signup',
        },
    },
    trust: [
        '🤝 Trusted by 1,000+ Companies',
        '⚡ No-Code Setup',
        '🧩 5,000+ Connected Apps',
        '🔄 Two-Way Data Sync',
    ],
}

export default pricingContent
